import React, { useState } from 'react'
import { Button, Typography, useTheme } from '@material-ui/core'
import { CustomerSupportModal } from '../../../../../../components/CustomerSupport/CustomerSupportModal'
import { Conversation } from '../../../types'
import { Container } from '../../../../../../components/Container'
import { useLoriState } from '../../../../../../contexts/LoriContext'

interface Props {}

export const ContactSupportButton = () => {
    const [openCustomerSupportModal, setOpenCustomerSupportModal] = useState(
        false,
    )
    const theme = useTheme()

    return (
        <Container
            style={{
                flexDirection: 'column',
                border: `2px solid ${theme.palette.divider}`,
                borderRadius: theme.shape.borderRadius,
                padding: theme.spacing(2),
            }}
        >
            <Container>
                <Typography variant="body1" color="textSecondary">
                    Sorry I didn&apos;t get the job done. Click the button below
                    to submit a ticket. Thanks for the feedback!
                </Typography>
            </Container>
            <Container
                style={{
                    marginLeft: theme.spacing(1),
                    borderLeft: `2px solid ${theme.palette.divider}`,
                    borderRadius: theme.shape.borderRadius,
                }}
            ></Container>
            <Container
                style={{
                    marginTop: theme.spacing(1),
                    justifyContent: 'center',
                }}
            >
                <Button
                    variant="contained"
                    style={{
                        backgroundColor: theme.palette.grey[300],
                        color: theme.palette.getContrastText(
                            theme.palette.grey[300],
                        ),
                        border: `2px solid ${theme.palette.primary.main}`,
                        fontWeight: 700,
                    }}
                    onClick={() => setOpenCustomerSupportModal(true)}
                >
                    Submit Ticket
                </Button>
            </Container>

            <CustomerSupportModal
                open={openCustomerSupportModal}
                onClose={() => setOpenCustomerSupportModal(false)}
            />
        </Container>
    )
}
